import type { Campaign } from "@contracts/api";

/** refId ของรายงาน KOL ที่ผูกไว้กับแคมเปญของแบรนด์นี้ (ไม่ซ้ำ) */
export function kolRefsOf(campaigns: Campaign[] | undefined): string[] {
  return [
    ...new Set(
      (campaigns ?? []).flatMap((c) =>
        (c.links ?? []).filter((l) => l.kind === "kol").map((l) => l.refId),
      ),
    ),
  ];
}
